import { differenceInYears, isBefore, isToday, isPast } from 'date-fns';
import { MONTH } from '../constants/gregorian_calendar_terms.json';
import { isEmptyString } from '../helpers/validation';

export const LEGAL_AGE = 16;
const CUTOFF_HOUR_FOR_SAME_DAY_DELIVERY = 11; // 11:00 AM

// TODO: Consider moving isValidDate to @lux/helpers
export const isValidDate = dob => {
  // replace all dashes and periods with slash
  let formatted = dob.replace(/\-/g, '/');
  formatted = formatted.replace(/\./g, '/');

  if (formatted.split('/').length > 3) {
    return false;
  }

  const day = Number(formatted.split('/')[0]);
  const month = Number(formatted.split('/')[1]);
  const year = Number(formatted.split('/')[2]);

  if (!day || !month || !year || isNaN(day) || isNaN(month) || isNaN(year)) {
    return false;
  }

  if (year < 1900 || year > 3000 || month === 0 || month > 12) {
    return false;
  }

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
    monthLength[1] = 29;

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1];
};

/**
 * @param {*} date
 * Returns a new Date - Months in word is behaving differently in firefox
 */
export const preFormatDate = date => {
  const day = Number(date.split('-')[0]);
  const month = date.split('-')[1];
  const year = Number(date.split('-')[2]);
  const getMonthIndex = Number(MONTH.MEDIUM.indexOf(month) + 1);

  return new Date(`${year}-${getMonthIndex}-${day}`);
};

export const strToDate = date => {
  let formatted = date.replace(/-/g, '/');
  formatted = formatted.replace(/\./g, '/');

  const day = Number(formatted.split('/')[0]);
  const month = Number(formatted.split('/')[1]);
  const year = Number(formatted.split('/')[2]);

  return new Date(year, month - 1, day);
};

export const isAboveAgeLimit = (dob, ageLimit, currDate = new Date()) => {
  const dobDate = strToDate(dob);
  const age = differenceInYears(currDate, dobDate);
  return age >= ageLimit;
};

export const isBeforeCutOff = (
  currentDate = new Date(),
  cutOffDate = new Date(),
  cutOffHour = CUTOFF_HOUR_FOR_SAME_DAY_DELIVERY
) => {
  cutOffDate.setHours(cutOffHour);
  cutOffDate.setMinutes(0);
  cutOffDate.setMilliseconds(0);
  return isBefore(currentDate, cutOffDate);
};

export const getDateAfterDays = (n, today = new Date()) => {
  today.setDate(today.getDate() + n);
  return today;
};

export const checkDob = (
  dob,
  ageLimit = LEGAL_AGE,
  currentDate = new Date()
) => {
  let error = '',
    dateOfBirth = dob && dob.trim();
  if (!dateOfBirth || dateOfBirth === '') {
    error = 'Please enter your date of birth in this format DD/MM/YYYY.';
  } else if (!isValidDate(dateOfBirth)) {
    error = 'Please enter a valid date in this format DD/MM/YYYY.';
  } else if (!isAboveAgeLimit(dateOfBirth, ageLimit, currentDate)) {
    error = `Sorry, you must be ${ageLimit} years old and above to buy this plan.`;
  }
  return error;
};

export const convertToDate = date => {
  const day = Number(date.split('-')[2]);
  const month = Number(date.split('-')[1]);
  const year = Number(date.split('-')[0]);

  //Myinfo retrieved date has a diff format down to the second
  return new Date(year, month - 1, day, 23, 59, 59);
};

export const isDate = str => {
  if (isEmptyString(str) || typeof str === 'undefined') return false;

  //MyInfo retrieved date will always start with a year
  const checkDate =
    str.indexOf('-') === 4 ? convertToDate(str) : strToDate(str);

  //Is a valid date
  return checkDate instanceof Date && !isNaN(checkDate);
};

export const determineAvailableDates = allDates => {
  const newDelDatesAndTime = {};
  Object.keys(allDates).forEach(delDate => {
    const deliveryDate = preFormatDate(delDate);
    const isSameDayDel = isToday(deliveryDate);

    //Save only future dates or before cutoff for same day delivery
    if (
      (isSameDayDel && isBeforeCutOff()) ||
      (!isSameDayDel && !isPast(deliveryDate))
    ) {
      newDelDatesAndTime[delDate] = allDates[delDate];
    }
  });
  return newDelDatesAndTime;
};
